import React from "react";
import { Link } from "react-router-dom";
import { useSiteLogo } from "../api/siteLogo";

const SITE_EMAIL = process.env.REACT_APP_EMAIL || "support@kademy.com";
const SITE_PHONE = process.env.REACT_APP_PHONE || "+91 99999 99999";
const SITE_ADDRESS = process.env.REACT_APP_ADDRESS || "Kademy HQ, India";

function Sidebar() {
  const logo = useSiteLogo();
  return (
    <div
      className="sidebar-popup offcanvas offcanvas-end"
      tabIndex="-1"
      id="sidebarPopup"
    >
      <div className="offcanvas-header">
        {/* Logo */}
        <Link to="/" className="sidebar-popup-logo">
          <img
            src={logo}
            alt="Kademy Logo"
            className="sidebar-logo-img"
          />
        </Link>

        <button type="button" className="btn-close" data-bs-dismiss="offcanvas">
          <i className="far fa-xmark"></i>
        </button>
      </div>

      <div className="sidebar-popup-wrap offcanvas-body">
        <div className="sidebar-popup-content">
          {/* ABOUT SECTION */}
          <div className="sidebar-popup-about">
            <h4>About Us</h4>
            <p>
              Kademy is your trusted platform to learn new skills, upgrade
              knowledge and grow in your career.
            </p>
          </div>

          {/* CONTACT SECTION */}
          <div className="sidebar-popup-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <div className="icon">
                  <i className="far fa-envelope"></i>
                </div>
                <div className="content">
                  <h6>Email</h6>
                  <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>
                </div>
              </li>

              <li>
                <div className="icon">
                  <i className="far fa-phone"></i>
                </div>
                <div className="content">
                  <h6>Phone</h6>
                  <a href={`tel:${SITE_PHONE}`}>{SITE_PHONE}</a>
                </div>
              </li>

              <li>
                <div className="icon">
                  <i className="far fa-location-dot"></i>
                </div>
                <div className="content">
                  <h6>Address</h6>
                  <p>{SITE_ADDRESS}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* SOCIAL LINKS */}
          <div className="sidebar-popup-social">
            <h4>Follow Us</h4>
            <a href="#">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#">
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
